/* src/app/components/contract/contract.component.css */
.form-group {
  width: 700px;
}
/*# sourceMappingURL=contract.component.css.map */
